import styled from 'styled-components';
import CloseIcon from '../../assets/images/close-btn.svg';

const CrossIcon = styled.span`
  background: url(\"${CloseIcon}\") no-repeat left center;
  background-size: 20px 20px;
  display: block;
  position: relative;
  width: 20px;
  height: 20px;
`;

export default CrossIcon;
